import { Alert, Button, Collapse, Group, ScrollArea, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";

type FailedAlertProps = {
  errorMessage?: string | object;
};

const FailedAlert: React.FC<FailedAlertProps> = ({ errorMessage }) => {
  const [showDetail, setShowDetail] = useState(false);
  const [parsedError, setParsedError] = useState<string | null>(null);

  useEffect(() => {
    try {
      if (typeof errorMessage === "string") {
        setParsedError(errorMessage);
      } else if (errorMessage != null) {
        setParsedError(JSON.stringify(errorMessage, null, 2));
      } else {
        setParsedError(null);
      }
    } catch {
      setParsedError(null);
    }
  }, [errorMessage]);

  return (
    <Alert color="red" bg={"#fededc"} style={{ borderColor: "#ed8180" }} variant="light" p="xs" w="100%">
      <Text c={"#9c2626"}>Datainnhenting mislyktes. Ta kontakt med mcapps@multiconsult.no for mer informasjon.</Text>

      {parsedError && (
        <>
          <Group mt="sm" justify="flex-start">
            <Button variant="subtle" size="compact-sm" onClick={() => setShowDetail((v) => !v)}>
              Se teknisk feilmelding
            </Button>
          </Group>

          <Collapse in={showDetail}>
            <ScrollArea mt="sm" h={180} type="auto">
              <pre style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 12 }}>
                {parsedError}
              </pre>
            </ScrollArea>
          </Collapse>
        </>
      )}
    </Alert>
  );
};

export default FailedAlert;
